import { jsx, jsxs } from 'react/jsx-runtime';
import { Stack } from '@fluentui/react';
import PopularCategoriesAndIndustries from './PopularCategoriesAndIndustries/PopularCategoriesAndIndustries.esm.js';
import { AppContext } from '../context/context.esm.js';
import PopularSolutions from './PopularSolutions/PopularSolutions.esm.js';
import Hero from './Hero/Hero.esm.js';

var Home = function(param) {
    var navigate = param.navigate, onRenderTiles = param.onRenderTiles, locale = param.locale, bannerBackgroundImage = param.bannerBackgroundImage, searchProps = param.searchProps, _param_unifiedExperience = param.unifiedExperience, unifiedExperience = _param_unifiedExperience === void 0 ? false : _param_unifiedExperience;
    return /*#__PURE__*/ jsx(AppContext.Provider, {
        value: {
            navigate: navigate,
            unifiedExperience: unifiedExperience,
            user: {
                loading: false,
                signedIn: false
            },
            searchProps: searchProps
        },
        children: /*#__PURE__*/ jsxs(Stack, {
            horizontalAlign: "center",
            styles: {
                root: {
                    width: '100%'
                }
            },
            children: [
                /*#__PURE__*/ jsx(Hero, {
                    navigate: navigate,
                    locale: locale,
                    bannerBackgroundImage: bannerBackgroundImage,
                    unifiedExperience: unifiedExperience,
                    searchProps: searchProps
                }),
                /*#__PURE__*/ jsx(PopularSolutions, {
                    navigate: navigate,
                    onRenderTiles: onRenderTiles,
                    locale: locale,
                    unifiedExperience: unifiedExperience
                }),
                /*#__PURE__*/ jsx(PopularCategoriesAndIndustries, {
                    navigate: navigate,
                    locale: locale,
                    unifiedExperience: unifiedExperience
                })
            ]
        })
    });
};

export { Home as default };
